import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=f1b26e50&scoped=true&"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=f1b26e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b26e50",
  null
  
)

export default component.exports